import React from 'react';

const PaginatorControllerContext = React.createContext();

export default PaginatorControllerContext;
